import KeenSlider from 'https://cdn.skypack.dev/keen-slider'

import VimeoVideo from './vimeo-video.js'

class MediaGallery extends HTMLElement {
  constructor () {
    super()
    this.slidesEl = this.querySelector('[data-media-gallery-el="slides"]')
    this.slideEls = this.querySelectorAll('[data-media-gallery-el="slide"]')
    this.thumbnailsEl = this.querySelector('[data-media-gallery-el="thumbnails"]')
    this.thumbnailEls = this.querySelectorAll('[data-media-gallery-el="thumbnail"]')

    this.nextArrow = this.querySelector('[data-media-gallery-el="next"]')
    this.prevArrow = this.querySelector('[data-media-gallery-el="prev"]')

    this.vimeoVideo = {
      player: this.querySelector('vimeo-video'),
      slideIndex: Number(this.querySelector('[data-media-gallery-video]')?.closest('[data-media-gallery-slide-index]')?.dataset?.mediaGallerySlideIndex),
    }

    this.gallery = this.initialiseGallery()
  }

  initialiseGallery () {
    return new KeenSlider(this.slidesEl, {
      mode: 'snap',
      rtl: false,
      loop: true,
      controls: true,
      spacing: 5,
      slidesPerView: 1,
      slides: '.prd-Media_Slide',
      created: () => {
        this.dataset.initialised = true
        this.thumbnailEls?.forEach(el => {
          el.addEventListener('click', this.handleThumbnailClick.bind(this))
        })

        this.nextArrow?.addEventListener('click', this.handleNextClick.bind(this))
        this.prevArrow?.addEventListener('click', this.handlePrevClick.bind(this))
      },
      slideChanged: instance => {
        this.thumbnailEls.forEach(el => {
          el.setAttribute(
            'aria-current',
            parseInt(el.dataset.mediaGalleryIndex) === instance.track.details.rel,
          )
        })

        if (this.vimeoVideo.player) {
          const currentIndex = instance.track.details.rel
          if (this.shouldPlayVideo(currentIndex)) {
            this.vimeoVideo.player.play()
          } else {
            this.vimeoVideo.player.pause()
          }
        }
      },
    })
  }

  handleThumbnailClick (e) {
    const indexEl = e.target.closest('[data-media-gallery-index]')
    const index = parseInt(indexEl.dataset.mediaGalleryIndex)

    if (!index) return
    
    if (indexEl.dataset.mediaGalleryVideoThumbnail) {
      this.vimeoVideo.player.play()
    }

    this.gallery.moveToIdx(index)
  }

  handleNextClick () {
    this.gallery.next()
  }

  handlePrevClick () {
    this.gallery.prev()
  }

  shouldPlayVideo (currentIndex) {
    return this.vimeoVideo.slideIndex >= currentIndex - 1
      && this.vimeoVideo.slideIndex <= currentIndex + 1
  }

  get activeThumbnailEl () {
    return this.thumbnailsEl.querySelector('[aria-current="true"]')
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery)
}

class ImageZoom extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-image-zoom-el="slides"]')
    this.slideEls = this.querySelectorAll('[data-image-zoom-el="slide"]')
    this.nextArrow = this.querySelector('[data-image-zoom-el="next"]')
    this.prevArrow = this.querySelector('[data-image-zoom-el="prev"]')

    this.closeButton = this.querySelector('[data-image-zoom-el="close"]')

    this.triggerEls = document.querySelectorAll('[data-image-zoom-el="openTrigger"]')

    this.mediaGallery = document.querySelector('media-gallery')

    this.triggerEls.forEach(triggerEl => {
      triggerEl.addEventListener('click', this.handleTriggerClick.bind(this))
    })

    this.closeButton.addEventListener('click', this.closeGallery.bind(this))

    this.ariaBusy = false
    this.gallery = this.initialiseGallery();
  }

  initialiseGallery () {
    return new KeenSlider(this.slidesEl, {
      mode: 'snap',
      rtl: false,
      loop: true,
      controls: true,
      spacing: 5,
      slidesPerView: 1,
      slides: '.prd-ImageZoom_Slide',
      created: () => {
        this.dataset.initialised = true

        this.nextArrow?.addEventListener('click', this.handleNextClick.bind(this))
        this.prevArrow?.addEventListener('click', this.handlePrevClick.bind(this))

        window.addEventListener('touchstart', (e) => {
          if (e.touches.length === 2) {
            this.gallery.update({drag: false})
          }

          if (this.isZoomed) {
            this.gallery.update({drag: false})
          } else {
            this.gallery.update({drag: true})
          }
        })

        window.addEventListener('touchend', (e) => {
          if (e.touches.length === 2) {
            this.gallery.update({drag: true})
          }

          if (this.isZoomed) {
            this.gallery.update({drag: false})
          } else {
            this.gallery.update({drag: true})
          }
        })
      },
      move(instance) {
        debugger
        if (isZoomed) {
          instance.stop()
        }
      }
    })
  }

  handleNextClick () {
    this.gallery.next()
  }

  handlePrevClick () {
    this.gallery.prev()
  }

  handleTriggerClick (e) {
    const targetSlide = this.externalCurrentSlide

    if (this.gallery.track.details.size <= targetSlide) return

    this.gallery.moveToIdx(targetSlide, 0)
    this.toggleGalleryVisibility()
  }

  toggleGalleryVisibility () {
    const body = document.querySelector('body')
    body.classList.toggle('image-zoom-active')
  }

  closeGallery () {
    const body = document.querySelector('body')
    body.classList.remove('image-zoom-active')
  }

  get externalCurrentSlide () {
    return this.mediaGallery.gallery.track.details.rel
  }

  get isZoomed () {
    return window.innerWidth < screen.width
  }
}

if (!customElements.get('image-zoom')) {
  customElements.define('image-zoom', ImageZoom)
}
